import { render, staticRenderFns } from "./volumeSet.vue?vue&type=template&id=22eb2e7b&scoped=true&"
import script from "./volumeSet.vue?vue&type=script&lang=js&"
export * from "./volumeSet.vue?vue&type=script&lang=js&"
import style0 from "./volumeSet.vue?vue&type=style&index=0&id=22eb2e7b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb2e7b",
  null
  
)

export default component.exports